{
  "common": {
    "show": "Vis",
    "about": "Om",
    "newPost": "Nytt innlegg",
    "active": "Aktiv",
    "change": "Endre",
    "remove": "Fjern",
    "cancel": "Kanseller",
    "publish": "Publiser",
    "save": "Lagre",
    "draft": "Utkast",
    "scheduled": "Planlagt",
    "published": "Publisert",
    "actions": "Handlinger",
    "archive": "Arkiver",
    "delete": "Slett",
    "edit": "Rediger",
    "edited": "Redigert",
    "settings": "Innstillinger",
    "signUp": "Registrer deg",
    "by": "Via",
    "for": "for",
    "you": "Du",
    "one": "én",
    "option": "Alternativ ",
    "registered": "Registrert",
    "to": "til",
    "allEvents": "Alle hendelser",
    "placeholder": "plassholder",
    "percentOf": "% av",
    "private": "Privat",
    "updatedOn": "Oppdatert den",
    "blogPost": "Blogginnlegg",
    "category": "Kategori",
    "author": "Forfatter",
    "status": "Status",
    "errors": "Feil",
    "all": "Alle",
    "archived": " Arkivert",
    "back": "Tilbake",
    "restore": "Tilbakestill denne versjonen",
    "next": "Neste",
    "previous": "Forrige",
    "continue": "Fortsett",
    "continueButton": "Fortsett",
    "paid": "Betalt",
    "free": "Gratis",
    "uploadImagesVideos": "Last opp bilder/videoer",
    "upload": "Last opp",
    "add": "Legg til",
    "on": "På",
    "from": "fra",
    "members": "medlemmer",
    "visibility": "Synlighet",
    "public": "Offentlig",
    "description": "Beskrivelse",
    "managedBy": "Administrert av",
    "noManagers": "Ingen behandlere",
    "noDescription": "Ingen beskrivelse",
    "more": "mer",
    "moreCaps": "Flere",
    "less": "mindre",
    "and": "og",
    "in": "i",
    "allSet": "Du er klar!",
    "createdBy": "Opprettet av",
    "home": "Hjem",
    "selected": "Utvalgt",
    "groupMembers": "Gruppemedlemmer",
    "everyone": "Alle",
    "manager": "Ansvarlig",
    "leave": "Forlat",
    "membersList": "Medlemsliste",
    "findChannelManagers": "Finn kanaladministratorer",
    "searchGroupMembers": "Søk etter gruppemedlemmer",
    "searchMembers": "Søk etter medlemmer",
    "searchMember": "Søk etter medlem",
    "enterDescription": "Angi beskrivelse",
    "apply": "Bruk",
    "selectRole": "Velg rolle",
    "people": "Mennesker",
    "viewProfile": "Se profil",
    "leaderboard": "Ledertavle",
    "events": "Hendelser",
    "logOut": "Logg ut",
    "topLevelReached": "Toppnivå nådd",
    "topLevelReachedExclaim": "Toppnivå nådd!",
    "congratsTopLevel": "Gratulerer! Du har nådd toppnivået!",
    "share": "Del",
    "copyLink": "Kopier lenke",
    "reply": "Svar",
    "download": "Last ned",
    "noPreviewAvailable": "Ingen forhåndsvisning tilgjengelig",
    "userNotFound": "Bruker ble ikke funnet",
    "userNotFoundMessage": "Bruker ikke funnet",
    "thisGroupIsPrivate": "Denne gruppen er privat",
    "unableToPreviewPdf": "For øyeblikket kan du ikke forhåndsvise PDF-filen. Last den ned for å se den.",
    "failedToDownloadPdf": "Kunne ikke laste ned PDF-filen",
    "notifyAll": "Gi beskjed til alle i kanalen",
    "communities": "Lokalsamfunn",
    "courses": "Kurs",
    "affiliates": "Tilknyttet",
    "chats": "Chat",
    "switchToDarkMode": "Bytt til mørk modus",
    "switchToLightMode": "Bytt til lys modus",
    "editProfile": "Rediger profil",
    "account": "Konto",
    "logout": "Logg ut",
    "noResults": "Ingen resultater",
    "confirmPayment": "Bekreft betaling",
    "done": "Fullført",
    "manage": "ADMINISTRER",
    "copied": "Kopiert",
    "submit": "Send inn",
    "request": "Forespørsel",
    "approve": "Godkjenn",
    "decline": "Avslå",
    "comingSoon": "Kommer snart",
    "detailsUpdatedSuccessfully": "Detaljene har blitt oppdatert",
    "oopsUnableToSaveDetails": "Oops! Kan ikke arkivere detaljer.",
    "verificationFailedPleaseTryAgain": "Verifisering mislyktes. Prøv igjen",
    "loading": "Laster",
    "title": "Tittel",
    "addLink": "Legg til lenke",
    "writeHere": "Skriv her",
    "copy": "Kopier",
    "reset": "Tilbakestill",
    "register": "Registrer deg",
    "search": "Søke",
    "confirm": "Bekreft",
    "success": "Vellykket",
    "toReview": "For å Vurdering",
    "invite": "Inviter",
    "contributions": "Bidrag",
    "communitiesSettings": "Innstillinger for fellesskap",
    "create": "Opprett",
    "name": "Navn",
    "linkCopied": "Lenke Kopiert.",
    "move": "Flytte",
    "irreversible": "irreversible",
    "close": "Lukk",
    "greeting": "Hei, {name}!",
    "managePayments": "Administrere betalinger",
    "manageYourAccount": "Administrere Konto din",
    "accountSettings": "Konto Innstillinger",
    "proceed": "Fortsett",
    "uploading": "Laster opp",
    "retry": "Prøv på nytt",
    "login": "Logg inn",
    "follow": "Følg",
    "following": "Følger",
    "followers": "Følgere",
    "view": "VIS",
    "selectAnOption": "Velg et alternativ",
    "channels": "Kanaler",
    "somethingWentWrong": "Noe gikk galt, prøv igjen",
    "switchToNormalMode": "Bytt til normalmodus",
    "switchToReadingMode": "Bytt til lesemodus",
    "goToHomepage": "Gå til startsiden",
    "onlyGroupOwnersCanCreateCourses": "Kun gruppeeiere kan opprette nye kurs",
    "createGroup": "Opprett gruppe",
    "discover": "Oppdag",
    "continuePayment": "Fortsett med betaling",
    "invalidCredentials": "Du har angitt en ugyldig e-postadresse eller passord. Prøv igjen.",
    "comingUpEvents": "Kommende hendelser!",
    "integratePaymentGateway": "Integrer betalingsgateway",
    "connectPaymentGateway": "Koble til en ny betalingsgateway eller administrer de nåværende.",
    "isLive": "er aktiv",
    "justNow": "Akkurat nå",
    "likes": "Likes",
    "accessRequired": "Tilgang*",
    "zeroProgress": "0",
    "noFollowersTitle": "Det ser ut som at ingen følger deg.",
    "noFollowersSubtext": "Legg til forbindelsen din i følgelisten",
    "noFollowingTitle": "Du følger ikke noen ennå.",
    "noFollowingSubtext": "Begynn å følge personer for å se innleggene deres",
    "followBack": "Følg tilbake",
    "logIn": "LOGG INN",
    "video": "Video",
    "audio": "Lyd",
    "newVersionAvailable": "En ny versjon av appen er tilgjengelig. Oppdater for å bruke denne funksjonen.",
    "ariaLabels": {
      "backButton": "Tilbakeknapp",
      "openEventLocation": "Åpne sted for hendelse",
      "editEvent": "Rediger hendelse",
      "deleteEvent": "Slett hendelse",
      "cancelRsvp": "Kansellere påmelding",
      "publicGroupRadio": "Radioknapp for offentlig gruppe",
      "privateGroupRadio": "Radioknapp for privat gruppe",
      "accessibleFromSwitcherCheckbox": "Tilgjengelig fra avmerkingsboksen i bryteren",
      "allowMembersToInviteCheckbox": "Avmerkingsboks for å la medlemmer invitere",
      "addMembers": "Legg til medlemmer",
      "settings": "Innstillinger",
      "leaveChannel": "Forlat kanal",
      "channelSettings": "Kanalinnstillinger",
      "selectRole": "Velg rolle",
      "deleteChannel": "Slett kanal",
      "changeToPrivateChannel": "Endre til privat kanal",
      "allowMembersToPosts": "Tillat medlemmer å legge ut innlegg",
      "restrictMembersFromPosts": "Begrense medlemmers mulighet til å sende innlegg",
      "close": "Lukke",
      "open": "Åpne",
      "more": "Flere",
      "upload": "Laste opp",
      "play": "Spille av",
      "pause": "Sette på pause",
      "mute": "Slå av lyden",
      "unmute": "Slå på lyden",
      "fullscreen": "Fullskjerm",
      "exitFullscreen": "Avslutt fullskjerm",
      "download": "Laste ned",
      "share": "Dele",
      "like": "Like",
      "comment": "Kommentere",
      "reply": "Svare",
      "pin": "Feste",
      "unpin": "Fjerne",
      "report": "Rapportere",
      "copyLink": "Kopiere lenke",
      "embedCode": "Sette inn kode",
      "previewImage": "Forhåndsvisning av bilde",
      "profileImage": "Profilbilde",
      "coverImage": "Forsidebilde",
      "thumbnail": "Miniatyrbilde",
      "attachment": "Vedlegg",
      "removeAttachment": "Fjerne vedlegget",
      "uploadFile": "Last opp fil",
      "selectFile": "Velg fil",
      "searchIcon": "Søkeikon",
      "menuIcon": "Menysymbol",
      "notification": "Varsling",
      "messages": "Meldinger",
      "profile": "Profil",
      "logout": "Logg ut",
      "send": "Send",
      "cancel": "Avbestill",
      "submit": "Send inn",
      "next": "Neste",
      "previous": "Forrige",
      "refresh": "Oppdater",
      "filter": "Filtrere",
      "sort": "Sortere",
      "view": "Vis",
      "expand": "Utvid",
      "collapse": "Legg ned",
      "downloadFile": "Last ned dokument",
      "closeModal": "Lukk modal",
      "addMedia": "Legg til medier",
      "lightModeRadio": "Radioknapp for lys modus",
      "darkModeRadio": "Radioknapp for mørk modus",
      "communityThemeRadio": "Radioknapp for fellesskapstema",
      "userProfile": "Brukerprofil",
      "postActions": "Dele aktiviteter",
      "chatWindow": "Chat-vindu",
      "chatActions": "Chat-handlinger",
      "minimizeChat": "Minimer chat",
      "closeChat": "Lukke chat",
      "commentActions": "Kommentarhandlinger",
      "replyToComment": "Svar på kommentar",
      "groupLogo": "Gruppelogo",
      "pinGroupIcon": "Fest gruppeikon",
      "appSwitcher": "App-bryter",
      "communities": "Fellesskap",
      "courses": "Kurs",
      "search": "Søke",
      "giphyLogo": "Giphy-logo",
      "backToConversations": "Tilbake til samtaler",
      "commentAttachments": "Kommentarvedlegg",
      "tabSwitcher": "Fanebryter",
      "eventCover": "Hendelsesomslag",
      "eventCoverPreview": "Forhåndsvisning av hendelsesomslag",
      "selectPaidEvent": "Velg betalt hendelse",
      "selectFreeEvent": "Velg gratis hendelse",
      "selectCurrency": "Velg valuta",
      "logo": "Logo",
      "closeReviewMembershipAnswersModal": "Lukk modal for gjennomgang av medlemskapssvar",
      "liveStream": "Direktesending",
      "openGroupMembers": "Åpne gruppemedlemmer",
      "communityBanner": "Fellesskapets banner",
      "home": "Hjem",
      "mentionItem": "Nevn punkt",
      "back": "Tilbake",
      "viewGroup": "Vis gruppe",
      "invitationIcon": "Invitasjonsikon",
      "openUserProfile": "Åpne brukerprofil",
      "closeStream": "Lukk strømmen",
      "groupAvatar": "Gruppeavatar",
      "bannerImage": "Bannerbilde",
      "avatarImage": "Avatarbilde",
      "userAvatar": "Brukeravatar",
      "eventImage": "Hendelsesbilde",
      "postImage": "Bilde for innlegg",
      "channelIcon": "Kanal-ikon",
      "groupIcon": "Gruppe-ikon",
      "communityIcon": "Fellesskapsikon",
      "memberAvatar": "Medlemsavatar",
      "creatorAvatar": "Skaperavatar",
      "authorAvatar": "Forfatter-avatar",
      "aboutFeaturedPost": "Om utvalgte innlegg",
      "accountSettings": "Kontoinnstillinger",
      "addChannel": "Legg til kanal",
      "addCourse": "Legg til kurs",
      "addEmoji": "Legg til emoji",
      "affiliates": "Partnere",
      "announceEvents": "Kunngjør hendelser",
      "avatar": "Avatar",
      "badge": "Skilt",
      "camera": "Kamera",
      "cardImage": "Bilde av kort",
      "categoryName": "Kategorinavn",
      "channelList": "Liste over kanaler",
      "channelSelect": "Velg kanal",
      "chatAttachment": "Chatvedlegg",
      "chats": "Chatter",
      "closeCourseDetails": "Lukk kursdetaljer",
      "closeLoginModal": "Lukke påloggingsmodal",
      "closeMembershipQuestionsModal": "Lukke modal for medlemskapsspørsmål",
      "closePaymentModal": "Lukke betalingsmodal",
      "commentCard": "Kommentarkort",
      "communityTheme": "Fellesskapstema",
      "conversationItem": "Samtalepunkt",
      "conversationSuggestion": "Samtaleforslag",
      "createChannel": "Opprett kanal",
      "customThemeRadio": "Radioknapp for tilpasset tema",
      "deleteAnswerButton": "Slett svar-knapp",
      "deleteFile": "Slett fil",
      "editLevelName": "Rediger nivånavn",
      "editProfile": "Rediger profil",
      "enterEmailAddress": "Skriv inn e-postadresse",
      "featuredIcon": "Utvalgt ikon",
      "giveAdministrativePrivileges": "Gi administrative privilegier",
      "gokollabLogo": "GoKollab-logo",
      "icon": "Ikon",
      "image": "Bilde",
      "likeContent": "Like innhold",
      "link": "Lenke",
      "marketplaceGroupSlug": "Marketplace-gruppe-slug",
      "microphone": "Mikrofon",
      "nextAttachment": "Neste vedlegg",
      "noEvents": "Ingen hendelser",
      "noCommunitiesIllustration": "Illustrasjon av manglende fellesskap",
      "noCoursesFound": "Ingen kurs ble funnet",
      "noFollowers": "Ingen følgere",
      "noFollowing": "Ingen følges",
      "noPostsFound": "Ingen innlegg funnet",
      "notificationItem": "Varslingselement",
      "notificationsList": "Varslingsliste",
      "openEmbeds": "Åpne «Sett inn»",
      "openEmbedsDrawer": "Åpne «Sett inn»-panelet",
      "openEventColor": "Åpne hendelsesfarge",
      "openEventDetails": "Åpne hendelsesdetaljer",
      "permissionNeeded": "Autorisasjon nødvendig",
      "pointsAndLevels": "Poeng og nivåer",
      "previousAttachment": "Tidligere vedlegg",
      "reactedUser": "Bruker som har reagert",
      "reward": "Belønning",
      "rewards": "Belønninger",
      "selectChannel": "Velg kanal",
      "selectEventOption": "Velg alternativ for hendelse",
      "selectIcon": "Velg ikon",
      "selectTimezone": "Velg tidssone",
      "showChannelIcons": "Vise kanal-ikoner",
      "sidebarActionButton": "Handlingsknapp for sidepanelet",
      "speaker": "Høyttaler",
      "text": "Tekst",
      "thisGroupIsPrivate": "Denne gruppen er privat",
      "toReview": "Til vurdering",
      "toggleFeaturedPost": "Veksle utvalgt innlegg",
      "toggleRewardsOptions": "Veksle belønningsalternativer",
      "viewReplies": "Se svar",
      "courseThumbnail": "kurs-miniatyrbilde",
      "moreManagers": "flere ledere",
      "arrowIcon": "→",
      "okHandEmoji": "👌",
      "closeIcon": "✕",
      "changeToPublicChannel": "Endre til offentlig kanal",
      "showMandatoryInfoModal": "Vis avmerkingsboks for obligatorisk profilmodal"
    },
    "placeholders": {
      "groupName": "Gruppenavn",
      "groupSlug": "Gruppe-slug",
      "url": "URL",
      "enterPrice": "Angi pris",
      "enterName": "Skriv inn navn",
      "enterEmail": "Skriv inn e-postadresse",
      "selectTimezone": "Velg tidssone",
      "selectChannel": "Velg kanal",
      "enterSkoolGroupUrl": "Skriv inn gruppe-URL til Skool"
    },
    "email": "E-post",
    "errorLoadingConversations": "Feil ved innlasting av samtaler",
    "noConversations": "Ingen samtaler"
  },
  "imageUpload": {
    "cropYourAvatar": "Beskjær avataren din",
    "dragToReposition": "Dra for å flytte",
    "ariaLabels": {
      "imageUploader": "Bildeopplaster",
      "avatar": "Avatar",
      "clearFile": "Fjern dokument",
      "removeAvatar": "Fjern brukerprofilbilde",
      "zoomButton": "Zoom-knapp"
    }
  },
  "mediaUpload": {
    "uploadVideo": "Last opp video",
    "addVideoUsingLink": "Legg til video via lenke",
    "uploadImage": "Last opp bilde",
    "addVideo": "Legg til video"
  },
  "mandatedInfoModal": {
    "completeYourProfile": "Fullfør profilen din",
    "profileIntentMessage1": "Fellesskap kan føles rare uten ansikter og navn.",
    "profileIntentMessage2": "Profiler bygger tillit og skaper forbindelser med andre",
    "complete": "FULLFØRT",
    "recommendedAspectRatio": "Last Laste opp en {types}. Anbefalt Utseende Prosentdel 1:1",
    "addBio": "Legg til en bio... (valgfritt)"
  },
  "validations": {
    "nameRequired": "Navn er påkrevd.",
    "invalidDescription": "Ugyldig beskrivelse."
  },
  "payment": {
    "recurringWithTrial": "Du vil bli belastet {currencySymbol}{price} per {interval} etter prøveperioden er over, med muligheten til å kansellere når som helst.",
    "recurring": "{currencySymbol}{price} per {interval}, med muligheten til å kansellere når som helst.",
    "oneTime": "{currencySymbol}{price} {paymentText}",
    "defaultOneTimeText": "engangspris for medlemskap.",
    "totalAmount": "Totalbeløp",
    "trialDays": "{days} dagers prøveperiode",
    "securePayments": "100 % sikre og trygge betalinger",
    "allowToChargeCard": "Ved å oppgi kortinformasjonen din, tillater du {locationName} å belaste kortet for fremtidige betalinger i samsvar med vilkårene deres.",
    "paymentSuccessful": "Betaling vellykket."
  },
  "channel": {
    "notifications": {
      "managersEdited": "Ansvarlige har blitt redigert.",
      "managersAdded": "Ansvarlige har blitt lagt til.",
      "managersAddedToChannel": "ansvarlige lagt til i",
      "membersAdded": "Medlemmene er lagt til",
      "memberPostingEnabled": {
        "title": "Oppdatert Medlemmer-innlegg vellykket",
        "content": "Medlemmers innlegg har vært Aktivert"
      },
      "roleUpdated": "Rollen ble oppdatert!",
      "updatedRoleOf": "Oppdatert rolle: {name}",
      "userRemoved": "Bruker ble fjernet.",
      "removedUserFrom": "Fjernet {name} fra {channelName}",
      "errorOccurred": "Det oppstod en feil",
      "updated": {
        "title": "Oppdaterte kanalinnstillinger",
        "contentPrivate": "Kanal {channelName} er nå privat",
        "contentPublic": "Kanal {channelName} er nå offentlig",
        "content": ""
      },
      "deleted": {
        "title": "Kanalen ble slettet",
        "content": ""
      },
      "membersAddedSuccess": {
        "title": "Medlemmene er lagt til",
        "content": "{count} medlemmer er lagt til i {channelName}"
      },
      "managersAddedSuccess": {
        "title": "Ansvarlige har blitt lagt til.",
        "content": "{count} ansvarlige er lagt til {channelName}."
      },
      "memberPostingDisabled": {
        "title": "Oppdatert Medlemmer-innlegg vellykket",
        "content": "Medlemmers innlegg har blitt deaktivert"
      },
      "visibilityChangedToPublic": "Kanalen {channelName} er nå offentlig",
      "visibilityChangedToPrivate": "Kanalen {channelName} er nå privat",
      "created": {
        "title": "Ny kanal opprettet",
        "content": ""
      },
      "error": {
        "createFailed": {
          "title": "Kan ikke opprette kanal",
          "content": "Prøv igjen senere"
        },
        "updateFailed": {
          "title": "Kunne ikke oppdatere kanalen",
          "content": "Prøv igjen senere"
        },
        "managersEditedFailed": {
          "title": "Oppdatering av ansvarlige var mislykket.",
          "content": ""
        },
        "addFailed": {
          "title": "Det var ikke mulig å legge til ledere.",
          "content": ""
        },
        "addMembersFailed": {
          "title": "Det var ikke mulig å legge til medlemmer.",
          "content": ""
        }
      }
    },
    "createChannel": "Skape KANAL",
    "updateChannel": "OPPDATERING AV KANAL",
    "addMembers": "Legg til medlemmer",
    "addManagers": "Legg til ansvarlige",
    "typeToAddMoreMembers": "Skriv inn for å legge til flere medlemmer",
    "examplePlaceholder": "f.eks. John eller Jane",
    "makeChannelManager": "Opprett kanaladministrator",
    "removeFromChannelManager": "Fjern fra kanaladministrator",
    "manager": "Ansvarlig",
    "channelManager": "Kanaladministrator",
    "noMembersFound": "Ingen medlemmer funnet.",
    "noManagersFound": "Ingen ansvarlige funnet.",
    "removeChannelMember": "Fjern kanalmedlem",
    "removeConfirmationMessage": "Er du sikker på at du vil fjerne",
    "makeManagerConfirmationMessage": "Er du sikker på at du vil gjøre",
    "makeManagerConfirmationMessage2": "til en kanaladministrator i",
    "channelName": "Kanalnavn",
    "channelIcon": "Kanalikon",
    "addChannel": "Legg til kanal",
    "editChannel": "Redigere kanal",
    "announcementChannel": "MERKNAD-kanalen",
    "noChannelsAvailable": "Ingen kanaler tilgjengelig",
    "makeChannelPrivate": "Gjør kanalen privat",
    "makeChannelPrivateMessage": "Begrens medlemmets tilgang til alle kanaldiskusjoner og interaksjoner.",
    "readOnlyChannel": "Lese kanal",
    "readOnlyChannelMessage": "Medlemmer kan se VIKTIG informasjon og oppdateringer, men kun administratorer/eiere av kanalen kan slette henne.",
    "createPrivateChannel": "Gjør denne kanalen privat",
    "createPrivateChannelMessage": "Kun inviterte Medlemmer . Ikke-medlemmer vil ikke se denne rom-en",
    "allowMembersToPost": "Aktivere Medlemmer til Dele",
    "allowMembersToPostMessage": "Aktiverer dette alternativet Aktivere medlemmer til Skape innlegg og tilbakemelding",
    "enableMemberPostingConfirmation": {
      "mainMessage": "Å aktivere Medlemmer-innlegg vil Aktivere hver eneste Medlemmer å Skape og slette innlegg i kanalen.",
      "mainMessage2": "Sikre at hver eneste medlemmer er klar over ny posting Tillatelser.",
      "pointer1": "Denne håndteringen kan tilbakestilles når som helst.",
      "pointer2": "hvert eneste innlegg Laget av Medlemmer vil være synlig for Alle in kanalen."
    },
    "privateChannelTooltip": "Du har ikke tilgang til denne kanalen",
    "restrictMembersFromPosting": "Begrens Medlemmer Fra-oppslag",
    "restrictMembersFromPostingMessage": "Deaktiver dette alternativet vil forhindre Medlemmer Fra Opprettet Eller å redigere innlegg og tilbakemelding i kanalen.",
    "disableMemberPostingConfirmation": {
      "mainMessage": "Deaktivering av medlemmer vil begrense hvert eneste medlem fra Opprettet og deling av innlegg i kanalen.",
      "mainMessage2": "Sikre at hver eneste medlem er klar over de nye postingsrestriksjonene.",
      "pointer1": "Denne håndteringen kan tilbakestilles når som helst.",
      "pointer2": "hvert eneste innlegg Laget av Medlemmer Før denne Endre vil forbli synlig for Alle in kanalen."
    },
    "deleteChannel": "Slett kanal",
    "deleteChannelMessage": "Sletting av kanalen vil føre til at alle tilknyttede data vil gå tapt for godt.",
    "deleteChannelMessageWithCourse": "Hvis du sletter kanalen, vil du miste hver eneste medlemmer-data permanent, og eventuelle kurs knyttet til denne kanalen vil bli offentlig med mindre du sletter dem først.",
    "editChannelName": "Rediger kanalnavn",
    "editChannelDescription": "Rediger kanalbeskrivelse",
    "channelNamePlaceholder": "f.eks. markedsføringsrapporter",
    "editManagers": "Rediger ledere",
    "channelManagers": "Kanaladministratorer",
    "leaveChannel": "Forlat kanal",
    "leaveChannelConfirmation": "Er du sikker på at du vil forlate denne kanalen?",
    "changeToPrivateChannel": "Gjør kanalen privat",
    "changeToPrivateChannelMessage": "Å gjøre kanalen privat vil begrense bruken av kanalen for interaksjoner og diskusjoner til kun medlemmer.",
    "changeToPrivateChannelConfirmation": {
      "mainMessage": "Å bytte denne kanalen til Privat vil kun SLOTMAX Tilgang til Valgt Medlemmer og ledere.",
      "mainMessage2": "Husk å inkludere hver eneste ønskede Medlemmer til din private kanal.",
      "pointer1": "Denne håndteringen er",
      "pointer2": "ny Medlemmer lagt til i kanalen vil ha Tilgang til hver eneste FORTID diskusjoner og interaksjoner i kanalen."
    },
    "changeToPublicChannel": "Gjør kanalen offentlig",
    "changeToPublicChannelMessage": "Å gjøre Kanalen offentlig vil aktivere alle Gruppe-medlemmer til å se og bli med i denne Kanalen.",
    "changeToPublicChannelConfirmation": {
      "mainMessage": "Å gjøre denne Kanal offentlig vil Skape den Offentlig for Alle fellesskap Medlemmer.",
      "mainMessage2": "Alle Gruppe-Medlemmer vil kunne Se og bli med in denne Kanal.",
      "pointer1": "Alle fellesskap Medlemmer vil ha Logg inn til denne Kanal automatisk.",
      "pointer2": "FORTID Privat Kanal Media vil bli synlig for Alle Gruppe Medlemmer."
    },
    "publicChannel": "Offentlig kanal",
    "peopleWhoCanManage": "Personer som kan administrere",
    "addChannelHelperText": "Vis mer fellesskap: Legge til-kanaler for diverse diskusjoner, Duet og tilkobling.",
    "privateChannel": "Privat kanal",
    "removeFromChannel": "Fjern fra kanalen",
    "removeConfirmationMessage2": "fra denne kanalen",
    "findChannelManagers": "Finn kanaladministratorer",
    "removeChannelManager": "Fjern kanaladministrator",
    "irreversible": "Denne handlingen er irreversibel"
  },
  "chat": {
    "unblockUser": "Fjern blokkering av bruker",
    "blockUser": "Blokker bruker",
    "blockMessage1": "Du vil ikke lenger kunne laste opp meldinger til denne brukeren.",
    "blockMessage2": "Denne kontoen vil ikke bli blokkert på gruppen. Det kan hende du fortsatt kan se innleggene, kommentarene og reaksjonene deres.",
    "deleteChat": "Slett chat",
    "deleteChatMessage": "Er du sikker på at du vil slette denne samtalen?",
    "block": "Blokker",
    "conversation": "samtale",
    "youPrefix": "Du: ",
    "messageNotSent": "Denne meldingen ble ikke sendt",
    "sending": "Sender",
    "youAndUserKnowEachOther": "Du og {name} kjenner hverandre",
    "startConversationWithHi": "Start en samtale ved å si «Hei»",
    "accountSettings": "Kontoinnstillinger",
    "blockedUserMessage": "Du har blokkert { name }. Dere kan ikke sende eller motta meldinger. Opphev blokkeringen for å starte en samtale. For å se gjennom listen din over blokkerte brukere, besøk din",
    "blockRecipientMessage": "{ name } har blokkert deg. Dere kan ikke sende eller motta meldinger.",
    "nothingFound": "Ingenting ble funnet.",
    "pleaseCheckUsername": "Vennligst sjekk brukernavnet og prøv på nytt",
    "startChatting": "Begynn å chatte",
    "noChatYet": "Det ser ut til at du ikke har chattet med noen ennå.",
    "noChatYetMessage": "Søk etter en kontakt og ta det første skrittet!",
    "noConversationsFound": "Ingen samtaler funnet",
    "searchMembersAndStartChatting": "Søk etter medlemmer og begynn å chatte",
    "cannotMessageDeletedUser": "Du kan ikke laste opp meldinger til en Slettet Bruker",
    "message": "Melding",
    "media": "Media",
    "files": "Filer"
  },
  "comments": {
    "reportComment": "Rapporter kommentar",
    "reportCommentMessage": "Er du sikker på at du vil rapportere denne kommentaren?",
    "deleteComment": "Slett kommentar",
    "editComment": "Rediger kommentar",
    "loadMoreReplies": "Last inn flere svar",
    "deleteCommentMessage": "Er du sikker på at du vil slette denne kommentaren?",
    "writeComment": "Skriv en kommentar",
    "comment": "KOMMENTAR",
    "cancel": "KANSELLER",
    "save": "LAGRE",
    "replyingTo": "Svarer til",
    "newComment": "ny kommentar",
    "latest": "Siste",
    "onlyAdminsCanComment": "Kun fellesskapsadministratorer kan kommentere in denne kanalen.",
    "isCommentDisabledForPost": "tilbakemelding er Deaktivert for dette Dele.",
    "isCommentDisabledErrorContent": "Tilbakemelding er Deaktivert på dette Dele via Editor eller Gruppe Admin.",
    "isCommentDisabledErrorTitle": "Tilbakemelding Deaktivert"
  },
  "embeds": {
    "uploadImage": "Last opp bilde",
    "addYoutubeVimeoLoomLink": "Legg til en Youtube-, Vimeo- eller Loom-lenke",
    "uploadAttachment": "Last opp PDF-, CSV- eller XLSX-filer",
    "addAttachment": "Legg til vedlegg",
    "allowedTypes": "SVG-, PNG-, JPG- eller GIF-fil (maks. 800x400px)",
    "placeholder": "Legg til en Youtube-, Vimeo- eller Loom-lenke",
    "uploadVideo": "Last opp / link til video",
    "uploadVideoPlaceholder": "Legg til en Youtube-, Vimeo- eller Loom-lenke",
    "uploadVideoAllowedTypes": "Last opp en MP4-videofil",
    "addEmoji": "Legg til emoji",
    "emojiSuggestion": "Åpner emoji-velgeren",
    "addGif": "Legg til GIF-fil",
    "gifSuggestion": "Åpner GIF-velger",
    "addImage": "Legg til bilde",
    "imageSuggestion": "Åpner galleriet ditt",
    "addVideo": "Legg til video",
    "videoSuggestion": "Åpner galleriet ditt",
    "selectFile": "Velg fil",
    "attachmentSuggestion": "Åpner filbehandler",
    "takePhoto": "Ta bilde",
    "uploadPhotoVideo": "Last opp foto/video",
    "limitExceeded": "Grensen er nådd",
    "limitExceededMessage": "Du kan ikke legge ved mer enn fire filer",
    "errorWhileUploadingFile": "Feil under opplasting av fil. Prøv igjen",
    "clickToUpload": "Klikk for å laste opp",
    "orDragAndDrop": "eller dra og slipp",
    "validUrl": "Gyldig URL er nødvendig",
    "enterSomeText": "Skriv inn tekst",
    "addLink": "Legg til lenke",
    "text": "Tekst",
    "addVideoLink": "Eller, Inkludere a YouTube, Vimeo, Loom, Eller Wistia Video Lenke.",
    "uploadVideoAndImages": "Laste opp videoer og bilder",
    "recommendedAspectRatio": "Anbefalt Utseende Prosentdel {ratio}",
    "addHashtag": "Merk kanaler, hendelser og kurs",
    "hashtagSuggestion": "Forslag til emneknagger"
  },
  "tabSwitcher": {
    "discussion": "Diskusjon",
    "learning": "Læring",
    "members": "Medlemmer",
    "people": "Mennesker",
    "leaderboard": "Ledertavle",
    "channels": "Kanaler",
    "groups": "Grupper",
    "more": "Mer",
    "home": "Hjem",
    "discover": "Oppdag",
    "courses": "Kurs",
    "communities": "Lokalsamfunn"
  },
  "groupInfo": {
    "pinGroup": "Fest Gruppe",
    "unpinGroup": "Løsne Gruppe",
    "maxPinnedGroupsLimit": "Kun opptil 4 grupper kan festes",
    "publicGroup": "Offentlig gruppe",
    "privateGroup": "Privat gruppe",
    "coverImage": "Gruppedekning",
    "members": "Medlemmer",
    "posts": "Innlegg",
    "admin": "Admin",
    "settings": "INNSTILLINGER",
    "inviteMembers": "INVITER MEDLEMMER",
    "answerQuestions": "Svar på spørsmål",
    "toJoin": "for å bli med i {name}",
    "changeRole": "Endre rolle",
    "removeFromGroup": "Fjern fra gruppen",
    "contributor": "Bidragsyter",
    "membershipAnswers": "Svar om medlemskap",
    "unbanMember": "Fjern utestengelse av medlem",
    "banFromGroup": "Utesteng fra gruppe",
    "requestedOn": "Forespurt",
    "invitedOn": "Invitert",
    "joinedOn": "Ble med",
    "noMembersFound": "Ingen medlemmer funnet.",
    "youAreAllCaughtUp": "Du er hver eneste gang – ingen medlemmer her Høyre nå!",
    "banUserConfirmation": "Er du sikker på at du vil utestenge denne brukeren fra gruppen?",
    "deleteContentCheckbox": "Slett hver eneste Innhold Laget av denne Bruker",
    "active": "Aktiv",
    "admins": "Administratorer",
    "contributors": "Bidragsytere",
    "requested": "Forespurt",
    "banned": "Utestengt",
    "invited": "Invitert",
    "paymentReceived": "Betaling mottatt",
    "paymentInitiated": "Betaling igangsatt",
    "answeredQuestions": "Besvarte spørsmål",
    "answeredQuestionsMessage": "svarte på følgende spørsmål for å bli med",
    "darkMode": "Mørk modus",
    "darkModeMessage": "Juster utseendet på fellesskapet for å redusere gjenskinn og gi øynene dine en pause.",
    "accessGranted": "Tilgang godkjent: Begynn læringseventyret ditt.",
    "stepIntoAction": "Sett i gang! La oss samarbeide og ha det gøy.",
    "viewMembersAndMemberDetails": "Se medlemmer og medlemsdetaljer",
    "reviewContentReportsAndMore": "Gjennomgå innholdsrapporter og mer",
    "toReview": "Til vurdering",
    "switchToOtherGroups": "Bytt til Annen/annet Gruppe",
    "placeholders": {
      "yourAnswer": "Ditt svar"
    },
    "notifications": {
      "userBanned": "Brukeren ble utestengt fra gruppen",
      "somethingWentWrong": "Noe gikk galt. Prøv igjen senere."
    },
    "membershipSettings": "Medlemskapsinnstillinger",
    "paymentFailed": "Betaling mislyktes.",
    "paymentFailedMessage": "Betaling mislyktes, og forespørselen din om å bli med i gruppen har blitt avvist.",
    "gamification": {
      "addRewards": "Legg til belønninger",
      "title": "Tittel",
      "description": "Legg til beskrivelse",
      "textbox": "Tekstboks",
      "singleSelect": "Enkeltvalg",
      "multipleSelect": "Flere valg",
      "question": "Spørsmål",
      "validations": {
        "titleRequired": "Vennligst oppgi tittel",
        "descriptionRequired": "Vennligst gi en beskrivelse",
        "somethingWentWrong": "Noe gikk galt. Prøv igjen senere.",
        "updatedRewards": "Oppdaterte belønninger"
      },
      "settings": {
        "updatedRewards": "Oppdaterte belønninger"
      }
    },
    "customCode": {
      "advanced": "Avansert",
      "testPreview": "Test forhåndsvisning",
      "enableConfirmationMessage": "Aktiver det bare når du har bekreftet testforhåndsvisningen",
      "testPreviewMessage": "Dette åpner en ny fane med testforhåndsvisningen av fellesskapet ditt. Du kan bruke denne til å sjekke om den egendefinerte koden fungerer som forventet.",
      "liveMode": "Direkte modus",
      "customJS": "Tilpasset JS",
      "customCSS": "Tilpasset CSS",
      "trackingCode": "Sporingskode",
      "headerCode": "Kode",
      "footerCode": "Bunntekst Kode"
    },
    "branding": {
      "brandYourGroup": "Du kan profilere gruppen din etter eget valg her",
      "updateBranding": "Oppdater profilering",
      "clickToUploadFavicon": "Klikk for å laste opp Favicon",
      "dragAndDropFavicon": "Dra og slipp en {types} (Størrelsesforhold 1:1)",
      "clickToUploadCover": "Klikk for å laste opp dekke",
      "dragAndDropCover": "Dra og slipp en {types} (Størrelsesforhold 16:9)",
      "clickToUploadLogo": "Klikk for å laste opp gruppelogo",
      "dragAndDropLogo": "Dra og slipp en {types} (Størrelsesforhold 1:1)",
      "aspectRatioMustBe1To1": "Størrelsesforholdet til bildet må være 1:1",
      "aspectRatioMustBe16To9": "Størrelsesforholdet til bildet må være 16:9",
      "favicon": "Favicon",
      "coverImage": "Forsidebilde",
      "logo": "Logo",
      "invalidFileFormat": "Oi! Ugyldig filformat/-type.",
      "pleaseUploadImageType": "Støttede filtyper: {types}"
    },
    "groupAppearance": {
      "description": "Du kan konfigurere din Gruppe Utseende per ditt valg her",
      "slug": "Oppdater Gruppe Utseende her",
      "colorMode": "Farge",
      "previewTheLook": "Forhåndsvisning hvordan gruppen din vil Utseende in Lyst- og Mørk-modus",
      "light": "Lyst",
      "dark": "Mørk",
      "communityTheme": "fellesskap Tema",
      "customTheme": "Tilpasset Tema",
      "windowGradient": "Vindu- Gradient",
      "applyGradientColorsToYourSidebarAndTopbar": "Iverksette Gradient til sidefeltet og topplinjen",
      "labels": {
        "sidebarBackground": "Bakgrunn for sidefelt",
        "primary": "PRIMÆR",
        "secondary": "Sekundær",
        "tertiary": "Tertiær",
        "surface": "Overflate",
        "fontPrimary": "PRIMÆR Font",
        "fontSecondary": "Sekundær skrift",
        "fill": "Fylle Farge",
        "border": "Kant",
        "error": "Feil",
        "background": "Bakgrunn",
        "option": "Alternativ"
      },
      "customThemes": {
        "default": "Standard",
        "zestyCitrus": "Sjarmerende sitrus",
        "royalVelvet": "Royal Velvet",
        "sunnyDelight": "Sunny Delight",
        "lushMeadow": "Frodig eng",
        "azureDreams": "Azure drømmer",
        "bubblegumBliss": "Bubblegum Bliss",
        "ivoryWhisper": "Ivory Whisper",
        "midnightDeep": "Midnight Deep"
      },
      "unsavedChanges": "Ikke-lagret Dynamisk",
      "unsavedChangesMessage": "Du har ulagret Tema Dynamisk, er du sikker på at du vil Angre the Dynamisk?"
    },
    "promotionalLinks": {
      "promotionalLinks": "Kampanjelenker",
      "createPromotionalLinkDescription": "Opprett kampanjelenker for gruppen din",
      "addPromotionalLink": "Legg til lenke",
      "deleteLink": "Slett lenke",
      "deleteLinkConfirmation": "Er du sikker på at du vil slette denne lenken?",
      "labels": {
        "description": "Beskrivelse",
        "url": "URL",
        "private": "Privat",
        "privateLinksDescription": "Private lenker er bare synlige for gruppemedlemmer"
      },
      "placeholders": {
        "enterLinkDescription": "Skriv inn lenkebeskrivelse",
        "enterLinkURL": "Skriv inn lenke-URL"
      },
      "addPromotionalLinkDescription": "Skape Kampanjelenker for din gruppe",
      "ariaLabels": {
        "editLink": "Rediger lenke",
        "deleteLink": "Slett lenke"
      }
    },
    "membershipQuestions": {
      "addQuestion": "Legg til spørsmål",
      "editQuestion": "Rediger spørsmål",
      "editLevelName": "Rediger nivånavn",
      "addOption": "Legg til alternativ",
      "level": "Nivå",
      "name": "Navn",
      "addMembersQuestionsDescription": "Legg til spørsmål for medlemmer som kan stilles når de ber om tilgang til gruppen din",
      "enableMembershipQuestions": "Aktiver spørsmål om medlemskap",
      "membershipQuestions": "Spørsmål om medlemskap",
      "deleteQuestion": "Slett spørsmål",
      "deleteQuestionConfirmation": "Er du sikker på at du vil slette dette spørsmålet?",
      "labels": {
        "textBox": "Tekstboks",
        "singleSelect": "Enkeltvalg",
        "multipleSelect": "Flere valg",
        "enableMembershipQuestions": "Legge til minst ett Spørsmål til Aktivere medlemskap spørsmål"
      },
      "validations": {
        "questionRequired": "Skriv inn spørsmål",
        "answerOptionsRequired": "Minst to alternativer er påkrevd, og de må være unike",
        "somethingWentWrong": "Noe gikk galt. Prøv igjen senere.",
        "updatedQuestions": "Oppdaterte spørsmål om gruppemedlemskap",
        "levelNameRequired": "Angi nivånavn",
        "updatedLevelName": "Oppdatert nivånavn"
      },
      "placeholders": {
        "enterLevelName": "Nivånavn",
        "selectOne": "Velg en",
        "keepItShort": "Hold det kort...",
        "exampleOffer": "f.eks 10 % deaktivert ved første kjøp"
      },
      "privacyNotice": "Jeg forstår at svarene mine vil være Lagret og synlige for Gruppe-administratorer.",
      "ariaLabels": {
        "editQuestion": "Rediger spørsmål",
        "deleteQuestion": "Slett spørsmål"
      }
    },
    "gamificationAndRewards": {
      "title": "Tilpass nivåer og belønninger",
      "description": "Tilpass nivånavn og inkluder belønninger for bedre engasjement av medlemmene",
      "gamification": "Gamifisering",
      "rewards": "Belønninger",
      "addRewards": "Legg til belønning",
      "ariaLabels": {
        "toggleGamification": "Slå alternativer for gamifisering på/av"
      }
    },
    "invitations": {
      "invitationSentSuccessfully": "Invitasjonen ble sendt",
      "invitationSentSuccessfullyDescription": "Invitasjonen ble sendt til {email}",
      "shareGroupLink": "Del gruppelenken din",
      "inviteMember": "Inviter medlem",
      "inviteMemberDescription": "Bygg opp fellesskapet ditt ved å invitere et nytt medlem",
      "inviteViaEmail": "Inviter via e-post",
      "invitedMembersWillBeAutoApproved": "Inviterte medlemmer blir automatisk godkjent til å bli med i gruppen",
      "sendInvite": "SEND INVITASJON",
      "permissionDenied": "Du har ikke Autorisasjon til å invitere Medlemmer. Ta kontakt med administratoren din.",
      "labels": {
        "giveAdministrativePrivileges": "Gi administrative privilegier",
        "giveAdministrativePrivilegesDescription": "Tillat at dette medlemmet kan utføre alle administrative handlinger",
        "name": "Navn",
        "email": "E-post",
        "nameLabel": "Navn",
        "emailLabel": "E-post"
      },
      "placeholders": {
        "enterName": "Skriv inn navn",
        "enterEmail": "Skriv inn e-postadresse"
      }
    },
    "groupDetails": {
      "updateGroupDetails": "Oppdater gruppedetaljer",
      "updateGroupDetailsDescription": "Oppdater gruppedetaljene dine her",
      "slugNotAvailable": "Gruppe-slug ikke tilgjengelig",
      "description": "Utdyp hva slags diskusjoner som vil finne sted i gruppen",
      "publicDescription": "Alle kan se gruppeinnleggene og andre medlemmer av gruppen",
      "privateDescription": "Bare medlemmer kan se gruppeinnleggene og andre medlemmer av gruppen",
      "accessibleFromSwitcher": "Tilgjengelig fra bryteren",
      "accessibleFromSwitcherDescription": "Gruppen din vil være synlig for ikke-gruppemedlemmer i bryteren",
      "allowMembersToInvite": "Aktivere Medlemmer for å invitere nye Medlemmer",
      "allowMembersToInviteDescription": "Skjul invitasjonen Knapp for Medlemmer Når slått Deaktivert. Medlemmer kan bare invitere Annen/annet Hvis dette er Aktivert.",
      "showMandatoryInfoModal": "Vis obligatorisk profilmodal",
      "showMandatoryInfoModalDescription": "Når denne funksjonen er aktivert, vil medlemmene bli bedt om å fylle ut profilinformasjonen sin når de blir med i gruppen.",
      "slug": "Gruppe-slug",
      "discovery": {
        "title": "Oppdagelse",
        "description": "Bli funnet av millioner av aktive brukere. Gruppen vil være synlig på siden Oppdag når du har flere enn ti medlemmer.",
        "discoverChannels": "Oppdage kanaler",
        "joinGroupToExploreAllChannels": "bli med gruppen for å utforske hver eneste kanalene",
        "categoryIsUsedOnlyOnGokollab": "Kategorien brukes kun på GoKollab",
        "categoryAutomaticallySuggested": "Kategorien foreslås automatisk ved hjelp av AI basert på gruppens tittel og beskrivelse. For å få et mest mulig nøyaktig forslag må du sørge for at gruppens formål og temaer kommer tydelig frem.",
        "categoryRefreshLimited": "Kategorioppdatering er begrenset til én gang per døgn."
      },
      "placeholders": {
        "description": "Skriv inn en kort beskrivelse"
      },
      "validations": {
        "nameRequired": "Skriv inn et gyldig gruppenavn.",
        "slugRequired": "Skriv inn en gyldig gruppe-slug.",
        "specialCharacterNotSupported": "Spesialtegn støttes ikke",
        "descriptionRequired": "Gruppebeskrivelse er påkrevd.",
        "emailRequired": "Skriv inn en gyldig e-post.",
        "fullNameRequired": "Vennligst skriv inn et gyldig navn."
      },
      "labels": {
        "groupName": "Gruppe"
      }
    },
    "subscriptions": {
      "manageSubscriptions": "Administrer tilknytningen din",
      "viewAndManageGroupSubscriptions": "Se og Administrere Gruppe Abonnement",
      "paymentIntegrationMissingMessage": "Vennligst integrer betalinger in Sted til Aktivere Betalt Gruppe",
      "price": "Pris",
      "currency": "Valuta",
      "priceDisplay": "{symbol}{price}{suffix}",
      "priceInterval": "/{interval}",
      "oneTime": " Én Dato",
      "priceDeletedAlert": "Betalingsprodukt er Fra Synkronisering, klikk her for å synkronisere på nytt",
      "intervals": {
        "month": "Måned",
        "year": "År",
        "week": "Uke",
        "day": "Dag"
      },
      "addNewPrice": "Legge til til ny Pris",
      "editPrice": "Redigere Pris",
      "addPrice": "Legge til Pris",
      "subscriptionType": {
        "recurring": "Gjentakende",
        "oneTime": "Én Dato"
      },
      "billingPeriod": {
        "monthly": "Månedlig",
        "annually": "Årlig",
        "weekly": "Ukentlig",
        "daily": "Daglig"
      },
      "ariaLabels": {
        "freeMembership": "Radioknapp for gratis medlemskap",
        "paidMembership": "Radioknapp for betalt medlemskap"
      }
    },
    "menuOptions": {
      "details": "Detaljer",
      "subscriptions": "Abonnement",
      "branding": "Merkevarebygging",
      "themes": "Tema",
      "tabsConfiguration": "Vis / Skjul faner",
      "membershipQuestions": "Spørsmål om Medlemskap",
      "gamificationAndRewards": "Gamifisering og belønninger",
      "links": "Lenker",
      "newsletter": "Nyhetsbrev",
      "reportedContent": "Rapportert Innhold",
      "discovery": "Oppdagelse",
      "import": "Import"
    },
    "newsletter": {
      "title": "Nyhetsbrev",
      "subheading": "Ditt fellesskapsoppsummering",
      "frequency": "Nyhetsbrevfrekvens",
      "description": "Et sammendrag av populære innlegg, medlemmenes aktivitet og hendelser fra denne gruppen",
      "selectFrequency": "Velg frekvens",
      "frequencies": {
        "off": "Av",
        "daily": "Daglig",
        "weekly": "Ukentlig",
        "biweekly": "To ganger i uken",
        "monthly": "Månedlig"
      }
    },
    "tabConfiguration": {
      "title": "Vis / Skjul faner",
      "description": "Kontroller hvilke faner som skal vises i samfunnet ditt. Aktiver eller deaktiver hver fane for å skape en fokusert og strømlinjeformet opplevelse for medlemmene dine.",
      "discussionDescription": "Start eller bli med i samtaler for å dele oppdateringer, ideer og innsikt med samfunnet ditt.",
      "learningDescription": "Opprett og administrer kurs som hjelper medlemmene med å tilegne seg nye ferdigheter eller kunnskap.",
      "eventsDescription": "Planlegg, organiser og se kommende økter, verksted eller arrangementer i samfunnet.",
      "leaderboardDescription": "Anerkjenn medlemmene med best resdultater, og oppmuntre til sunt engasjement gjennom rangeringer.",
      "membersDescription": "Administrer alle medlemmer og roller. Denne fanen vil forbli synlig for administratorene selv når den er deaktivert, slik at medlemsadministrasjon alltid er tilgjengelig.",
      "aboutDescription": "Introduser samfunnets formål, verdier og bakgrunn for å hjelpe medlemmene med å knytte kontakter.",
      "discussionTooltip": "Diskusjon er en sentral samfunnsfane og kan ikke deaktiveres",
      "aboutTooltip": "Om-fanen er nødvendig for å gi viktig samfunnsinformasjon, og kan ikke deaktiveres."
    },
    "groupSettings": {
      "groupSettings": "Gruppe Innstillinger",
      "changeGroupType": "Endre Gruppe Type",
      "changeGroupTypeDescriptionPrivateToPublic": "Dynamisk to a Offentlig Gruppe betyr at hver eneste I påvente av Forespørsler blir Godkjent automatisk, og Innhold vil bli offentlig synlig. Fortsette?",
      "changeGroupTypeDescriptionPublicToPrivate": "Dynamisk to a Privat Gruppe betyr at nye medlemmer trenger Godkjenning og Innhold forblir Skjult til de er Godkjent. Fortsette?",
      "changeGroupTypeConfirmation": "Er du sikker på at du vil Endre Gruppe Type?",
      "changeGroupTheme": "Endre Gruppe Tema",
      "changeGroupThemeDescription": "Dette vil Endre the Tema for hver eneste the Gruppe Medlemmer. Er du sikker på at du vil Endre Gruppe Tema?",
      "updatedGroupDetails": "Oppdatert gruppedetaljer",
      "unableToSaveDetails": "Oops! Kan ikke arkivere detaljer.",
      "groupNameIsRequired": "Gruppenavn er Obligatorisk",
      "groupDescriptionIsRequired": "Gruppebeskrivelse er obligatorisk",
      "groupSlugIsRequired": "Gruppe Slug er Obligatorisk",
      "groupSlugMustContainOnly": "Gruppe Slug må bare inneholde Små bokstaver bokstaver, mengde og bindestreker",
      "groupSlugAlreadyExists": "Gruppe Slug finnes allerede. Vennligst bruk en annen Slug , siden denne allerede er tatt",
      "groupSlugRestricted": "Denne sluggen samsvarer med et av våre private nøkkelord for fellesskapslenker. Bruk en annen slug",
      "pleaseTryAgainLater": "Vennligst prøv igjen senere",
      "unsavedChangesMessage": "Du har Gruppe Slug Dynamisk som ikke er lagret, er du sikker på at du vil angre dem?"
    },
    "import": {
      "header": "Import Skool Gruppe Medlemmer og deres Innhold",
      "credentialDescription": "Skriv inn Skool-sertifikatet ditt for å Import Gruppe Medlemmer og deres Innhold",
      "csvUploadDescription": "Velge .csv Fil for å Import kontakter Fra Skool",
      "loginFailed": "Du har skrevet inn et ugyldig e-post Eller password. Vennligst prøv igjen.",
      "proceedWithImport": "Fortsette med Import?",
      "iAgree": "Jeg er enig",
      "importTerms": "Ved å klikke på «Jeg godtar», bekrefter og anerkjenner Du at Du har engasjert oss som en uavhengig Avtale til å utføre Tjenester på dine vegne («Tjenester»). The Tjenester Inkludere the Overføre av certain data, Detaljer, Innhold, intellectual Egenskaper Eller any Annen/annet Innhold (\"Info\") Fra a Utstedt Platform Konto to a Mottatt Platform Konto. Du representerer og garanterer at (i) du er de rettmessige Eier av Info in Utstedt Platform Konto, (ii) Du har Tillatelser til å gi oss Tilgang til Utstedt Platform Konto for Hensikt av som utfører Tjenester, og (iii) Overføre av Info vil ikke krenke noen tredjeparts intellektuelle Egenskaper Tillatelser Eller bryte noen tredjepartskontrakter. Du samtykker i å holde oss skadesløs, forsvare og holde oss skadesløse for eventuelle tredjepartskrav som oppstår som et resultat av bruddet ditt av representantene og garantiene ovenfor.",
      "pleaseDownloadCSV": "Last ned .CSV-fil",
      "step01": "Skritt 01–",
      "step02": "Skritt 02–",
      "uploadCSV": "Last Laste opp .CSV",
      "step01Description": "Fylle in Eller oppdater eventuelle manglende detaljer for gruppemedlemmer som for eksempel Gmail, fornavn osv. Sørg for at CSV er lastet opp in",
      "thisTemplate": "denne Mal",
      "importCSV": "Import .CSV",
      "reSyncData": "Re-Synkronisering av dataene dine Før Laste ned.",
      "refreshUserList": "Oppdater Bruker Liste",
      "reSyncDataDescription": "Hvis nye brukere er lagt til in mellomtiden, foreslår vi at Du oppdaterer listen og laster ned CSV.",
      "pleaseDontChangeProfileSlug": "Vennligst ikke Endre Profil Slug.",
      "selectFile": "Velge Fil",
      "changeFile": "Fil Endre",
      "importMembersFailedText": "Dette kan være fordi de mangler e-postadresse. Vennligst Hake Import Fil og Prøv igjen med gyldig e-post-adresse for disse medlemmene.",
      "upload": "Laste opp",
      "tryAgain": "Prøv igjen",
      "syncAllPosts": "Synkronisering hver eneste din Slett og Kommenter",
      "membersCouldNotBeAdded": "Medlemmer kunne ikke legges til i gruppen.",
      "importMembersSuccess": "Vi har sendt en e-post til hver eneste Individ Gruppe Medlemmer, som bekrefter deres medlemskap in gruppen og gir dem Tilgang Detaljer. Dette bidrar til å sikre at hver eneste medlemmer er informert og kan Tilgang med Gruppen effektivt.",
      "importMembersAdded": "Medlemmer har blitt lagt til i gruppen",
      "postsNotSynced": "Gjenværende innlegg kunne ikke synkroniseres til gruppen. Dette kan være fordi Dele Forfattere ikke ble importert på hell.",
      "migrationFailed": "Migreringen mislyktes. Vennligst prøv igjen.",
      "migrationCompleted": "Migrasjon Ferdig!",
      "migrationInProgress": "Migrering pågår",
      "createProfile": "Opprett profil",
      "enterCredentials": "Skriv inn informasjon",
      "uploadingInProgress": "Siste opp in .",
      "listMembers": "Liste av Medlemmer blir",
      "downloaded": "Last ned",
      "uploaded": "lastet opp",
      "listPostsDownloaded": "Liste av innlegg er lastet ned.",
      "listPostsDownloading": "Liste av innlegg blir lastet ned.",
      "posts": "innlegg",
      "members": "Medlemmer",
      "imported": "importert",
      "step1": "Skritt 1",
      "step2": "Skritt 2",
      "step1Description": "Skape en medlemsprofil in Skool Gruppe.",
      "step1Description2": "(inkludert navn, e-post Id og passord)",
      "step2Description": "Skriv inn Skool Medlemmer Sertifikat",
      "skoolUrlPlaceholder": "Skriv inn gruppe-URL til Skool",
      "emailPlaceholder": "Skriv inn Skools e-post- Id",
      "emailTooltip": "Skriv inn e-posten Medlemmer med din skolekonto",
      "passwordPlaceholder": "Skriv inn Skool-passordet ditt",
      "confirm": "Bekreft",
      "validation": {
        "skoolUrl": "Skriv inn en gyldig Skool-URL",
        "email": "E-post er obligatorisk",
        "password": "Passordet er obligatorisk"
      }
    },
    "approved": "Godkjent",
    "pending": "Avventer",
    "rejected": "Avvist"
  },
  "invitations": {
    "intent": "Help dette fellesskapet å vokse.",
    "cancelInvitation": "Kanseller invitasjonen",
    "inviteMembers": "Inviter medlemmer til å samarbeide om dette fellesskapet.",
    "inviteLink": "Invitasjonslenke",
    "invitationLink": "invitasjonslenke",
    "buildYourCommunity": "Bygg ditt fellesskap.",
    "inviteMembersToCollaborate": "Du har opprettet et nytt fellesskap! Inviter medlemmer til å samarbeide om dette fellesskapet.",
    "invite": "Inviter",
    "basicInformation": "Grunnleggende informasjon",
    "permissions": "Tillatelser"
  },
  "createPost": {
    "title": "Opprett nytt blogginnlegg",
    "placeholder": "Hva tenker du på",
    "liveStream": "Direktesending",
    "slug": "Blogginnlegg – URL-slug",
    "titleHelp": "Tittelen, beskrivelsen og bildet vil bli brukt for SEO meta tag",
    "nameLabel": "Tittel på blogginnlegg",
    "nameValidation": "Tittel er påkrevd",
    "descriptionLabel": "Beskrivelse av innlegget",
    "descriptionHelp": "Gi en kort beskrivelse slik at seerne kan få et glimt av innlegget. Fungerer best mellom 100–250 tegn",
    "descriptionValidation": "Beskrivelse er påkrevd",
    "createLabel": "Opprett innlegg",
    "image": "Bilde av blogginnlegg",
    "imageDescription": "Anbefalt størrelse er 600px * 400px",
    "notificationTitle": "Blogginnlegg opprettet",
    "notificationErrorTitle": "Kunne ikke opprette blogginnlegg",
    "postingIn": "Legger in",
    "editingIn": "Redigering in"
  },
  "post": {
    "downloadRecording": "Laste ned opptak",
    "deletePost": "Slett innlegg",
    "reportPost": "Rapporter innlegg",
    "editPost": "Rediger innlegg",
    "createPost": "Opprett innlegg",
    "publish": "Innlegg",
    "publishPost": "Publiser innlegg",
    "addChannel": "Legg til kanal",
    "selectChannel": "Velg kanal",
    "addLink": "Legg til lenke",
    "removeLink": "Fjern lenke",
    "update": "Oppdater",
    "unsavedChanges": "Du har endringer som ikke er lagret",
    "unsavedChangesMessage": "Du vil miste endringene du ikke har lagret. Vil du fortsatt gå videre?",
    "unpinFromChannel": "Løsne",
    "unpinFromHome": "Løsne",
    "deletePostConfirmation": "Er du sikker på at du vil slette dette innlegget?",
    "reportPostConfirmation": "Er du sikker på at du vil rapportere dette innlegget?",
    "postNotFound": "Finner ikke innlegget",
    "postNotFoundMessage": "Innlegget du prøver å se er enten slettet eller det eksisterer ikke.",
    "loadMoreComments": "Last inn flere kommentarer",
    "channelNotFound": "Kanal ikke funnet",
    "isCurrentlyLive": "er for øyeblikket live",
    "isStartingNow": "begynner nå",
    "isHappeningInMinutes": "skjer om {minutes} minutter",
    "isHappeningInHours": "skjer in {hours} tid | skjer in {hours} tid",
    "publicChannel": "Offentlig kanal",
    "privateChannel": "Privat kanal",
    "featured": "Utvalgte",
    "featuredAbout": "Om utvalgte",
    "noPostsFound": "Ingen innlegg funnet",
    "pinInfo": "Du kan feste elementer som skal vises øverst i gruppen, inkludert innlegg, regler og emneknagger.",
    "pinInfoEveryone": "Alle i gruppen vil se disse elementene.",
    "pinInfoRemainVisible": "Festede elementer forblir synlige til du løsner dem.",
    "pinInfoNewestItem": "Når du fester elementer, vises det nyeste elementet først på listen.",
    "onlyVisibleToAdmins": "Kun synlig for administratorer",
    "featuredAboutDescription": "Administratorene dine har festet disse elementene slik at gruppen kan se dem.",
    "channelNotFoundMessage": "Du er ikke lenger medlem av kanalen du prøver å få tilgang til, eller kanalen er slettet.",
    "notifications": {
      "unpinned": "Løsnet.",
      "pinned": "Festet.",
      "reported": "Innlegget har blitt rapportert.",
      "error": "Noe gikk galt.",
      "isCommentDisabled": "Tilbakemelding deaktivert!",
      "isCommentEnabled": "Tilbakemelding aktivert!"
    },
    "movePostToChannel": "Flytte til kanal",
    "pin": "Pin",
    "pinToHome": "Fest til startsiden",
    "pinToChannel": "Fest til kanalen",
    "whatIsYourTitle": "Hva er din Tittel?",
    "postMovedToChannel": "Slett ble flyttet til {channelName} kanal",
    "upcomingEvent": "Kommende hendelse",
    "turnOffCommenting": "Deaktiver kommentering.",
    "enableComments": "Aktiver kommentarer",
    "disableComments": "Deaktiver tilbakemelding",
    "moveToPrivateChannelConfirmation": {
      "title": "Flytt til privat kanal",
      "message": "Du er i ferd med å flytte dette innlegget til en privat kanal. Kun medlemmer av den private kanalen vil kunne se den. Vil du fortsette?"
    },
    "onlyAdminsCanPost": "Kun fellesskapsadministratorer kan dele innlegg i denne kanalen."
  },
  "reaction": {
    "noLikes": "Ingen likes",
    "andOthers": "og {count} andre"
  },
  "UIConfirmation": {
    "privateGroup": "Denne gruppen er privat",
    "privateGroupMessage": "Du må være medlem av denne gruppen for å få tilgang til gruppespesifikk informasjon. Vennligst be om tilgang ved å klikke på Bli med i gruppe-knappen."
  },
  "notifications": {
    "noNotificationsYet": "Ingen varsler ennå",
    "whenYouGetNotifications": "Når du får varsler, vil de vises her",
    "markAllAsRead": "Merk alle som lest",
    "notifications": "Notifikasjoner",
    "all": "Alle",
    "unread": "Ulest",
    "checkNotifications": "Logg inn for å sjekke varsler",
    "noNotifications": "Ingen varsler.",
    "redirectedFromOldSlug": {
      "title": "Du har blitt omdirigert til den oppdaterte fellesskapslenken",
      "content": "Dette har blitt gjort for å forbedre SEO-ytelsen for dette fellesskapet. Vennligst Oppdatere bokmerkene dine med denne nye URL."
    }
  },
  "joinGroupModal": {
    "wahoo": "Jippi! 🎉 Forespørselen er sendt",
    "reviewRequestSoon": "Våre gruppeadministratorer vil snart vurdere forespørselen din. Vær tålmodig. Vi varsler deg når medlemskapet ditt er godkjent.",
    "nonMemberMessage": "Du må være en del av denne gruppen for å like og kommentere på innlegg",
    "subscribeFor": "Abonner på",
    "joinGroup": "BLI MED I GRUPPEN",
    "membershipPending": "Medlemskap PENDING",
    "viewMembershipAnswers": "Se svar på Medlemskap",
    "requested": "Forespurt",
    "dayFreeTrial": "dags gratis prøveperiode",
    "notPartOfGroup": "Du er ikke en del av denne gruppen ennå, ditt Medlemskap Forespørsler er in Vurdering. Når en Admin Godkjent din Forespørsler, vil vi varsle Du",
    "pleaseAnswerMembershipQuestions": "Vennligst svar på medlemskapsspørsmålene for å bli med denne gruppen",
    "answerQuestions": "Svar på medlemskapsspørsmål"
  },
  "userProfilePopover": {
    "active": "Aktiv",
    "longAgo": "lenge siden",
    "chatDisabled": "Denne brukeren har deaktivert chatten sin",
    "pointsToLevelUp": "poeng for å gå opp i nivå",
    "profile": "Profil",
    "deletedUser": "Slettet bruker",
    "joined": "Ble med",
    "contributions": "Bidrag"
  },
  "courses": {
    "courseRestricted": "Dette kurset er begrenset",
    "courseDeleted": "Dette kurset er blitt slettet",
    "noMatchingCourseFound": "Fant ingen matchende kurs",
    "addCourse": "Legg til kurs",
    "updateCourse": "Oppdater kurs",
    "access": "Alle medlemmer har tilgang",
    "unableToAddCourse": "Oops! Kan ikke inkludere kurs",
    "pleaseTryAgainLater": "Prøv igjen senere",
    "paymentIntegrationMissing": "Oops! Betalingsintegrering mangler",
    "paymentIntegrationMissingMessage": "Vennligst integrer betalinger på stedet for å aktivere betalte kurs",
    "course": "Kurs",
    "courseInThisGroup": "et eksisterende kurs i denne gruppen",
    "courseLinkCopied": "Kurslenke kopiert.",
    "buyNow": "KJØP NÅ",
    "locked": "LÅST",
    "buyCourse": "KJØP KURS",
    "open": "ÅPEN",
    "moveCard": "Flytt kort",
    "courseViewMessage": "Du må være en del av denne gruppen for å se kursene.",
    "deleteCourse": "Slett kurs",
    "deleteCourseConfirmation": "Er du sikker på at du vil slette dette kurset?",
    "courseAccessNotGranted": "Kurstilgang er ikke gitt",
    "courseAccessNotGrantedMessage": "Vi jobber for tiden med å gi deg tilgang til kurset. Oppdater siden og prøv igjen om et øyeblikk.",
    "autoRenewsAfter": "Fornyes automatisk etter",
    "oneTimePayment": "Engangsbetaling",
    "emptyCoursesMessage": "Ser ut som en spøkelsesby. Ingenting å se her",
    "updatedSuccessfully": "Kursoppdatert vellykket",
    "addedSuccessfully": "Kurset ble lagt til",
    "createCourse": "Opprett nytt kurs",
    "emptyCourseLibrary": "Rutebiblioteket ditt er tomt!",
    "createdOutsideGokollabMessage": "Dette fellesskapet ble opprettet utenfor Gokollab & gjort synlig. For å Generere nye Kurs, vennligst logg in på fellesskap fra Kilde Kanal",
    "createCourseOnGokollabMessage": "Generere et ny Rute på Gokollab for å gjøre det tilgjengelig for fellesskap Medlemmer.",
    "or": "eller",
    "createNewOne": "generere en ny",
    "labels": {
      "selectCourse": "Velg kurs",
      "courseVisibility": "Synlighet",
      "courseAccess": "Kurstilgang",
      "coursePrice": "Kurspris",
      "subscriptionType": "Abonnementstype",
      "billingPeriod": "Faktureringsperiode",
      "testMode": "Testmodus",
      "turnOnTestPayments": "Slå på testbetalinger med et testkort",
      "currency": "Valuta",
      "trialDays": "Prøveperiode",
      "recurring": "Gjentakende",
      "free": "Gratis",
      "oneTime": "Én Dato",
      "refresh": "Oppdater",
      "accessStartsAtDay": "Tilgangen starter Tilgang . Dag",
      "maximumYouCanEnterIs365": "Maks Du can enter er 365",
      "allMembers": "hver eneste Medlemmer",
      "levelUnlock": "Jevn Lås opp",
      "buyNow": "Kjøp nå",
      "timeUnlock": "Opplåsing av data",
      "gamificationLevel": "Gamifisering Jevn",
      "privateChannel": "Privat kanal",
      "marketingChannel": "Markedsføring",
      "selectCurrency": "Velg valuta"
    },
    "placeholders": {
      "enterPrice": "Angi pris",
      "enterTrialDays": "Angi prøvedager",
      "selectCurrency": "Velg en",
      "selectBillingPeriod": "Velg en",
      "billingPeriod": "Velge faktureringsperiode"
    },
    "validations": {
      "validPrice": "Vennligst skriv inn en gyldig pris",
      "required": "Velg et kurs",
      "validMembershipPrice": "Skriv inn gyldig medlemskapspris",
      "validTrialDays": "Vennligst oppgi gyldige prøvedager",
      "requiredSubscriptionType": "Vennligst velg abonnementstype",
      "courseVisibility": "Vennligst Velge kurs Synlighet",
      "requiredGamificationLevel": "Vennligst Velge Gamifisering Jevn",
      "requiredPrivateChannel": "Vennligst velg privat kanal",
      "validAccessStartDay": "Vennligst skriv inn gyldig Tilgang start Dag"
    },
    "descriptions": {
      "buyNowDescription": "Dette kurset er offentlig ved kjøp",
      "timeUnlockDescription": "Medlemmer Låse opp Etter X dager",
      "levelUnlockDescription": "Medlemmer bare på en viss Jevn vil kunne låse opp",
      "allMembersDescription": "hver eneste medlemmer har Tilgang til dette kurset",
      "privateChannelDescription": "Medlemmer av en privat kanal"
    },
    "helperText": {
      "levelBased": "Nivåbasert",
      "timeLimited": "tidsbegrenset",
      "free": "Gratis",
      "levelAvailableAt": "Tilgjengelig på Jevn 0{value}",
      "timeLimitedAfterJoining": "Offentlig {value} {day} Etter blir med i gruppen",
      "day": "Dag",
      "days": "dager",
      "purchaseToUnlockAccess": "Kjøp dette kurset for å låse opp Tilgang",
      "locked": "Dette kurset er låst",
      "unlockAtLevel": "Dette kurset vil låses opp på Jevn {level}",
      "unlockAfterDays": "Dette kurset vil låse opp Etter {days} {dayText}",
      "privateChannelBased": "Privat kanalbasert"
    },
    "ariaLabels": {
      "courseCard": "Kurskort",
      "courseCardActions": "Handlinger for kurskort",
      "editCourse": "Redigere kurs",
      "deleteCourse": "Slette kurs",
      "moveCard": "Flytte kort",
      "copyLink": "Kopiere lenke",
      "cardImage": "Bilde av kurskort"
    }
  },
  "about": {
    "notifications": {
      "errorUploadingFile": "Feil under opplasting av dokument"
    },
    "uploadLinkVideo": "Last opp / lenke til video",
    "removeMedia": "Fjern mediet {fileName}"
  },
  "leaderboard": {
    "level": "Nivå",
    "lastUpdated": "Sist oppdatert",
    "members": "Medlemmer",
    "percentOfMembers": "{percentage}% av medlemmene",
    "rewards": "Belønninger",
    "allTime": "Hele tiden",
    "pointsToLevelUp": "poeng for å gå opp i nivå",
    "points": "Poeng",
    "leaderboard7d": "Ledertavle (7 dager)",
    "leaderboard30d": "Ledertavle (30 dager)",
    "leaderboardAlltime": "Ledertavle (gjennom tidene)",
    "yourRank": "Din rangering",
    "noActivityToShow": "Ingen aktivitet å vise",
    "rewardsWillBeDisplayedHere": "Belønninger vil bli vist her",
    "seeAllLeaderboards": "Se alle ledertavler",
    "addRewards": "Legg til belønninger",
    "howPointsWork": "Du tjener poeng når andre medlemmer liker innleggene dine eller gir deg tilbakemelding. 1 like = 1 poeng. Dette oppfordrer brukere til å generere kvalitetsinnhold og samhandle med andre medlemmer i fellesskapet deres.",
    "levels": "Nivåer",
    "levelsDescription": "Etter hvert som du får poeng, går du opp i nivåene. Ditt nivå vises nederst til høyre for avataren din. Antall poeng som kreves for å komme til neste nivå vises via fremdriftslinjen på ledertavleskjermen.",
    "pointsAndLevels": "Poeng & Lag"
  },
  "events": {
    "createEvent": "Opprett hendelse",
    "dragAndDrop": "Dra og slipp en SVG-, PNG- eller JPG-fil (maks 800x400 piksler)",
    "editEvent": "Rediger hendelse",
    "addEvent": "Legg til hendelse",
    "paymentDetails": "Betalingsdetaljer",
    "event": "Hendelse",
    "goBack": "Gå tilbake",
    "cancelEdit": "Kanseller redigering",
    "cancelEvent": "Kanseller hendelsen",
    "next": "Neste",
    "saveEvent": "Lagre hendelse",
    "editRecurringEvent": "Rediger gjentakende hendelse",
    "thisEvent": "Denne hendelsen",
    "thisAndFollowingEvents": "Denne og de etterfølgende hendelsene",
    "ok": "OK",
    "deleteRecurringEvent": "Slett gjentakende hendelser",
    "allEvents": "Alle hendelser",
    "adminsFreeForPaidEvents": " * Administratorer kan registrere seg for Betalt Hendelser gratis",
    "deleteEvent": "Slett hendelse",
    "onceEventDeleted": "Når en hendelse er slettet, vil den ikke vises i kalenderen din.",
    "toRegister": "for å registrere",
    "calendar": "Kalender",
    "addToCalendar": "Legg til i kalenderen",
    "declineRegistration": "Avslå",
    "paymentFailedMessage": "Betalingen din mislyktes på grunn av uforutsette omstendigheter. Prøv igjen senere.",
    "upcoming": "Kommende",
    "noMoreEvents": "Ingen flere hendelser å vise",
    "joinGroupToRegister": "Du må være en del av denne gruppen for å registrere deg for denne hendelsen",
    "past": "Tidligere",
    "youHaveRegisteredForOneEvent": "Du har registrert deg for en hendelse. Vi sender deg en påminnelse en dag før hver hendelse.",
    "upcomingEvents": "Kommende hendelser",
    "noUpcomingEvents": "Ingen kommende hendelser",
    "pastEvents": "Tidligere hendelser",
    "noPastEvents": "Ingen tidligere hendelser",
    "noMatchingEventFound": "Fant ingen matchende hendelse",
    "week": "Uke",
    "month": "Måned",
    "today": "I dag",
    "registrationConfirmed": "Registrering Bekreftet for {event}.",
    "eventDeletedOrRestricted": "Hendelsen er slettet eller Privat",
    "eventDeleted": "Hendelsen er slettet",
    "eventRestricted": "Du har ikke tilgang til denne hendelsen",
    "validations": {
      "titleValidation": "Tittel er påkrevd",
      "colorValidation": "Farge er påkrevd",
      "startTimeValidation": "Starttid er påkrevd",
      "endTimeValidation": "Slutt-tid er påkrevd",
      "endTimeAfterStartTime": "Sluttidspunktet må være etter starttidspunktet",
      "startTimeMustBeInFuture": "Starttidspunktet må være i fremtiden",
      "locationValidation": "Sted er obligatorisk",
      "locationValidationMobile": "Sted er påkrevd",
      "locationUrlValidation": "Gyldig steds-URL er nødvendig",
      "descriptionValidation": "Beskrivelse er påkrevd",
      "descriptionValidationMaxLength": "Beskrivelsen kan ikke overstige 300 tegn",
      "recaptchaError": "Verifisering mislyktes. Prøv igjen",
      "repeatIntervalValidation": "Hyppighet er påkrevd",
      "repeatIntervalValidator": "Gjentakelsesintervall må være enten dag, uke, måned eller år",
      "repeatIntervalRequired": "Gjentakelsesintervall er påkrevd",
      "repeatOccurrenceValidator": "Gjentakelseshyppighet må være større enn 0",
      "repeatOccurrenceRequired": "Gjentakelseshyppighet er påkrevd",
      "invalidDateFormat": "Ugyldig dato format",
      "endDateMustBeAfterStartDate": "Sluttdatoen må være etter arrangementets startdato",
      "recurringEndDateValidation": "Gjentakende sluttdato er påkrevd",
      "repeatsOnValidation": "Velg minst én dag",
      "invalidDaySelection": "Ugyldig valg av dag",
      "endOptionRequired": "Slutt-alternativ er påkrevd",
      "levelValidation": "Velg et nivå",
      "courseValidation": "Velg et kurs",
      "channelValidation": "Velg en kanal",
      "eventPriceValidation": "Pris er obligatorisk og må være større enn {min}"
    },
    "placeholders": {
      "selectStartTime": "Velg starttid",
      "selectEndTime": "Velg sluttid",
      "selectLocation": "Velg sted",
      "locationUrl": "Lenke/adresse",
      "description": "Beskrivelse",
      "selectRecurringEndDate": "Velg gjentakende sluttdato",
      "selectDate": "Velg dato",
      "event": "Hendelse",
      "selectColor": "Velg en farge",
      "selectAttendees": "Velg deltakere",
      "selectPrivateChannel": "Velg privat kanal",
      "selectCourse": "Velg kurs",
      "selectLevels": "Velge nivåer",
      "selectCalendar": "Velg kalender"
    },
    "labels": {
      "startTime": "Starttid",
      "endTime": "Sluttid",
      "others": "Andre",
      "oneTimePriceForEventRegistration": "engangspris for påmelding til arrangementet.",
      "totalAmount": "Totalbeløp",
      "cardAuthorizationText": "Ved å oppgi kortinformasjonen din, tillater du {locationName} å belaste kortet for fremtidige betalinger i samsvar med vilkårene deres.",
      "secureAndSafePayments": "100 % sikre og trygge betalinger",
      "day": "Dag",
      "week": "Uke",
      "month": "Måned",
      "year": "År",
      "recurringEvent": "Vil arrangementet være en gjentakende hendelse?",
      "repeatsEvery": "Gjentas hver/hvert",
      "repeatsOn": "Gjentas",
      "end": "Slutt",
      "ends": "Lukke",
      "neverEnds": "Tar aldri slutt",
      "orange": "Oransje",
      "red": "Rød",
      "blue": "Blå",
      "green": "Grønn",
      "violet": "Fiolett",
      "purple": "Lilla",
      "yellow": "Gul",
      "title": "Tittel",
      "color": "Farge",
      "allMembers": "Alle medlemmer",
      "membersAtALevel": "Medlemmer på et nivå",
      "membersOfACourse": "Medlemmer av et kurs",
      "membersOfAPrivateChannel": "Medlemmer av en privat kanal",
      "whoCanAttendTheEvent": "Hvem kan delta på arrangementet?",
      "channel": "Kanal",
      "course": "Kurs",
      "level": "Nivå",
      "remindAttendeesByEmail": "Minn deltakere Via E-post 1 Dag Før",
      "hideLocationFromNonAttendees": "Skjul sted fra ikke-deltakere.",
      "addChargesToTheEvent": "Legge til fakturering til hendelsen",
      "noPaymentRequired": "Ingen betaling Obligatorisk",
      "location": "Sted",
      "link": "Lenke",
      "description": "Beskrivelse",
      "timezone": "Tidssone",
      "eventType": "Hendelsestype",
      "eventTypeChangeWarning": "Dynamisk to the Hendelsestype Eller pricing vil Iverksette til hver eneste hendelse in serien.",
      "never": "Aldri",
      "on": "På",
      "after": "Etter",
      "occurrences": "hendelser",
      "selectEventEnd": "Velge Når the Hendelse will Slutt.",
      "turnOnTestPayments": "Vend På Test Via Test",
      "pay": "Betale",
      "hideAttendees": "Skjul deltakere Fra Gruppe Medlemmer",
      "guests": "{count} gjester",
      "guestList": "Gjest Liste",
      "noAttendees": "Ingen deltakere ennå",
      "viewAttendees": "Se",
      "exportAttendees": "Eksport deltakere"
    },
    "notifications": {
      "eventCreated": "Hendelse vellykket Opprettet!",
      "eventUpdated": "Hendelse vellykket Oppdatert!",
      "eventCreationFailed": "Oppretting av Hendelse mislyktes.",
      "eventUpdateFailed": "Oppdatering av Hendelse mislyktes.",
      "eventDeleted": "Hendelsen er slettet.",
      "eventDeletionFailed": "Sletting av hendelse mislyktes.",
      "paymentFailed": "Betaling mislyktes.",
      "registrationSuccessful": "Registrering vellykket.",
      "registrationFailed": "Registrering mislyktes.",
      "addToCalendarFailed": "Kunne ikke legge til hendelsen i kalenderen.",
      "locationDetailsCopied": "Stedsdetaljer kopiert til utklippstavlen.",
      "registrationDeclined": "Registreringen ble avvist.",
      "registrationDeclinedFailed": "Avslag på registrering mislyktes.",
      "fetchAttendeesFailed": "Kunne ikke laste inn deltakere",
      "emailCopied": "E-post Kopier til utklippstavlen",
      "exportAttendeesFailed": "Kunne ikke eksportere deltakere"
    },
    "selectCalendar": "Velg kalender",
    "eventImage": "Hendelsesbilde",
    "errorLoadingEvent": "Feil ved innlasting av hendelse"
  },
  "login": {
    "invite": "inviterte deg til å bli med"
  },
  "contentReports": {
    "contentDeleted": "Innhold har blitt slettet.",
    "noActionTaken": "Ingen handling foretatt på det rapporterte innholdet.",
    "reportedContentNotFound": "Finner ikke rapportert innhold. Det kan hende at det allerede er gjort noe med det.",
    "reported": "Rapportert",
    "viewAllReportedContentHere": "Du kan se alt det rapporterte innholdet her",
    "takeActionOnReportedContent": "Reager på det rapporterte innholdet",
    "andOthers": "og {count} andre",
    "reportedThisPost": "rapporterte dette innlegget",
    "keep": "BEHOLD",
    "remove": "FJERN",
    "deleteContent": "Slett innhold",
    "deleteConfirmation": "Er du sikker på at du vil slette dette innholdet?",
    "noMemberReportedContent": "Ingen innholdsrapporter fra medlemmer",
    "whenMembersReportPostsOrComments": "Når medlemmer rapporterer innlegg eller tilbakemeldinger, vil det vises her slik at du kan vurdere det. Du kan beholde eller slette det, samt deaktivere, fjerne eller blokkere medlemmene som postet dem.",
    "reportedThisComment": "Du har rapportert denne kommentaren"
  },
  "contentUnavailable": {
    "thisContentIsntAvailable": "Dette innholdet er ikke tilgjengelig for øyeblikket",
    "whenThisHappens": "Når dette skjer, er det vanligvis fordi eieren bare har delt det med en liten gruppe personer eller endret hvem som kan se det, eller fordi det har blitt slettet"
  },
  "search": {
    "noResultsFor": "0 resultater for «{query}» i fellesskapet",
    "noResultsFound": "Fant ingen resultater"
  },
  "noCommunities": {
    "noCommunitiesFound": "Ingen fellesskap funnet",
    "startCreatingYourOwnCommunities": "Begynn å lage dine egne fellesskap og engasjere publikummet ditt.",
    "noCommunitiesFoundGokollab": {
      "notJoinedA": "Ikke blitt med i en",
      "communities": "Nettsamfunn",
      "yet": "Ennå"
    },
    "noCommunitiesFoundGokollabDescription": "Oppdag rom der folk deler ideer, støtter hverandre og vokser sammen."
  },
  "noCourses": {
    "noCoursesFoundGokollab": {
      "notEnrolledInA": "Ikke påmeldt i",
      "course": "Kurs",
      "yet": "Ennå"
    },
    "noCoursesFoundGokollabDescription": "Utforsk kvalitetsrike kurs som er utformet for å hjelpe deg med å lære, forbedre deg og lykkes."
  },
  "notFound": {
    "ohNo": "å nei...",
    "weHaveHadAnError": "Det har oppstått en feil",
    "error404": "Feilmelding 404",
    "sorryPleaseCheckBack": "Beklager... Kom tilbake snart."
  },
  "time": {
    "justNow": "Akkurat nå",
    "timeAgo": "{value} {unit} siden",
    "timeAgoFull": "{value} {unit} siden",
    "units": {
      "year": "å",
      "years": "år",
      "month": "md",
      "months": "måneder",
      "week": "u",
      "weeks": "uker",
      "day": "d",
      "days": "dager",
      "hour": "t",
      "hours": "timer",
      "minute": "m",
      "minutes": "minutter",
      "second": "s",
      "seconds": "Sekunder",
      "monthly": "Månedlig",
      "weekly": "Ukentlig",
      "annually": "Årlig"
    },
    "dayAbbreviations": {
      "mon": "Ma.",
      "tue": "Ti.",
      "wed": "On.",
      "thu": "To.",
      "fri": "Fr.",
      "sat": "Lø.",
      "sun": "Sø."
    }
  },
  "emojiPicker": {
    "notfound": "Ingen emoji funnet",
    "recent": "Mye brukt",
    "smileys": "Smileys og uttrykksikon",
    "people": "Mennesker og Hoveddel",
    "nature": "Dyr og natur",
    "foods": "Mat og drikke",
    "activity": "Aktivitet",
    "places": "Travel & Seter",
    "objects": "Objekter",
    "symbols": "Symboler",
    "flags": "Flagg",
    "custom": "Tilpasset"
  },
  "topNavBarHeaderText": {
    "discussion": "Diskusjon",
    "learning": "læring",
    "people": "Mennesker"
  },
  "globalUserProfile": {
    "ownedBy": "Eies av {name}",
    "memberships": "Medlemskap",
    "membershipsInCommon": "Medlemskap ({count} til felles)",
    "membersCount": "{count} medlemmer",
    "contributions": "{count} bidrag til {group}",
    "contributionsFor": "Bidrag til",
    "justPosts": "Kun innlegg",
    "postAndComments": "Innlegg og tilbakemeldinger",
    "followSuccess": "Du har begynt å følge",
    "unfollowSuccess": "Du følger ikke lenger."
  },
  "profile": {
    "active": "Aktiv",
    "ago": "siden",
    "bio": "Biografi"
  },
  "golive": {
    "golive": "Kjør direkte",
    "selectVideoSourceToStart": "Velg en videokilde for å starte strømming",
    "chooseHowToGoLive": "Velg hvordan du ønsker å kjøre direkte.",
    "flipCamera": "Snu kamera",
    "participants": "Deltakere",
    "chats": "Chatter",
    "react": "Reagere",
    "raise": "Heve",
    "shareScreen": "Dele",
    "letsCheckYourCamAndMic": "La oss sjekke kameraet og mikrofonen din",
    "hostedBy": "Vertskap:",
    "join": "Bli med",
    "needCameraPermission": "Trenger kameratillatelse",
    "needMicrophonePermission": "Trenger mikrofontillatelse",
    "needSpeakerPermission": "Trenger høyttalertillatelse",
    "createLiveVideo": "Opprett en live-video",
    "host": "Vert",
    "chooseWhereToPost": "Velge hvor du vil dele",
    "whenAreYouGoingLive": "Når skal du sende direkte?",
    "postingIn": "innlegg i",
    "live": "Live",
    "postDetails": "Detaljer om innlegget",
    "streamingSoftware": "Strømmeprogramvare",
    "streamingSoftwareDescription": "Du kan bruke strømmeprogramvare som Zoom, OBS eller StreamYard til å kringkaste direkte. Kopier ganske enkelt den medfølgende strømadressen og strømnøkkelen til innstillingene i strømmeprogramvaren din. Når du har konfigurert den, starter du sendingen i programvaren, og den strømmer automatisk direkte til den valgte plattformen.",
    "streamKey": "Strømmenøkkel",
    "streamKeyDescription": "Denne kan gjenbrukes hver gang du går live. Du kan bare sende én direktesendt video om gangen med den vedvarende strømmetasten din.",
    "serverUrl": "Server-URL",
    "serverUrlDescription": "Dette kan bli referert til som \"URL\" eller \"Adresse\" i strømmeprogramvaren din.",
    "selectVideoSource": "Velg videokilde",
    "copyPasteStreamKey": "Kopier og lim inn strømmenøkkelen i strømmeprogramvaren.",
    "copyPasteServerUrl": "Kopier og lim inn serverens URL i strømmeprogramvaren.",
    "addPostDetails": "Legg til detaljer om innlegget",
    "enterTitle": "Skriv inn en tittel",
    "notifyMembers": "Varsle medlemmene om at du går live (sender kun varsler i appen og push-varsler)",
    "notifyMembersMobile": "Varsle medlemmene om at du er live",
    "meetingRoom": "Møterom",
    "meetingRoomDescription": "Bruk møteromsfunksjonen til å arrangere direktesendte økter der alle deltakerne kan slå på webkameraene sine, slå av lyden og samhandle i sanntid. Dette skaper en virtuell romopplevelse som ligner på Zoom eller Google Meet, slik at alle kan se og snakke med hverandre ansikt til ansikt.",
    "cameraControls": "Kamerakontroller",
    "cameraControlsTooltip": "Konfigurer kamera- og lydinnstillingene før du kjører direkte. Kontroller at kameraet og mikrofonen er riktig tilkoblet og har de nødvendige tillatelsene.",
    "selectMediaSource": "Velg en mediekilde",
    "startScreenShare": "Start skjermdeling",
    "stopScreenShare": "Stopp skjermdeling",
    "wasLive": "var direkte",
    "isLive": "er aktiv",
    "goingLive": "kjør direkte",
    "tapToAddDescription": "Trykk for å legge til en beskrivelse ...",
    "selectChannel": "Velg kanal",
    "saveAsPost": "Behold direktestrøm som innlegg",
    "selectVideoSourceTooltip": "Du kan velge mellom strømmeprogramvare eller webkamera når du kjører direkte:\n\n1. Strømmeprogramvare\n • Vi gir deg en strømmenøkkel og en strømme-URL.\n   • Du må konfigurere disse i Zoom, OBS eller annen tredjepartsprogramvare som støtter direktestrømming.\n\n2. Webkamera\n • Kjør direkte via kameraet og mikrofonen.\n   • Deltagerne kan se direktestrøm og kommunisere via direktechat.\n   • Som vert kan du når som helst kontrollere og oppheve tilgangen til kameraet eller mikrofonen.",
    "pleaseSelectCameraMicrophoneSpeaker": "Velg kamera, mikrofon og høyttaler",
    "pleaseStartStreamBeforeGoingLive": "Start strømmen før du kjører direkte",
    "watching": "Ser på",
    "processingRecording": "Laster opptak",
    "streamEndedRecordingWillBeAvailableSoon": "Strømmen er avsluttet. Opptaket er under behandling og kan benyttes snart.",
    "joinStream": "Bli med på strømmen",
    "recordingInProgress": "Opptak pågår",
    "recordingNotAvailable": "Opptak er ikke tilgjengelig",
    "leaveSession": "Forlat økten",
    "endSession": "Avslutt økten",
    "rec": "REC",
    "selectCamera": "Velg kamera",
    "noCamerasFound": "Fant ingen kamera",
    "cameraPermissionNeeded": "Kameratillatelse er nødvendig",
    "leave": "Avslutt",
    "chooseMicCam": "Velg mikrofon/kamera",
    "selectMicrophone": "Velg mikrofon",
    "selectSpeaker": "Velge høyttaler",
    "noMicrophonesFound": "Fant ikke mikrofoner",
    "noSpeakersFound": "Fant ikke høyttalere",
    "microphonePermissionNeeded": "Mikrofontillatelse er nødvendig",
    "speakerPermissionNeeded": "Høyttalertillatelse er nødvendig",
    "noParticipantOpenCamOrMic": "Dette møtet ble ikke tatt opp, ettersom ingen av deltakerne hadde aktivert mikrofon eller kamera. Opptak opprettes kun når minst én deltaker er aktiv."
  }
}
